import Vue from 'vue'

import 'babel-polyfill'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue);
Vue.config.productionTip = false


// OVERALL
import top from "./components/overall_layouts/app-top.vue";
import Carousel from "./components/overall_layouts/carousel.vue";
import Navbar from "./components/overall_layouts/navbar.vue";
import mediaItems from "./components/overall_layouts/media-items.vue";
import partners from "./components/overall_layouts/partners.vue";
import foot from "./components/overall_layouts/footer.vue"; 
import footerLinks from "./components/overall_layouts/footer_links.vue"; 
import bookSlider from "./components/overall_layouts/book-slider.vue";
import bookSlider_logotop from "./components/overall_layouts/book-slider-logotop.vue";
import Rightbody from "./components/overall_layouts/rightBody.vue";
import sidebarCarousel from "./components/overall_layouts/sidebar-carousel.vue";
import sidebarImage from "./components/overall_layouts/sidebar-image.vue";
import sidebarSocial from "./components/overall_layouts/sidebar-social.vue";
import sidebarFacebook from "./components/overall_layouts/sidebar-facebook.vue";
import pagination from "./components/overall_layouts/pagination.vue";
import bookDisplay from "./components/overall_layouts/book-display.vue";
import bookDetails from "./components/overall_layouts/book-details.vue";
import newsitem from "./components/overall_layouts/newsitem.vue";
import bbncContent from "./components/overall_layouts/bbnc-content.vue";
import staff from "./components/overall_layouts/staff.vue";


Vue.component('top',top);
Vue.component('Carousel',Carousel);
Vue.component('Navbar',Navbar);
Vue.component('media-items',mediaItems);
Vue.component('partners',partners);
Vue.component('foot',foot);
Vue.component('footer-links',footerLinks);
Vue.component('bookSlider',bookSlider);
Vue.component('bookSlider_logotop',bookSlider_logotop);
Vue.component('Rightbody',Rightbody);
Vue.component('sidebar-carousel',sidebarCarousel);
Vue.component('sidebar-image',sidebarImage);
Vue.component('sidebar-social',sidebarSocial);
Vue.component('sidebar-facebook',sidebarFacebook);
Vue.component('pagination',pagination);
Vue.component('bookDisplay',bookDisplay);
Vue.component('bookDetails',bookDetails);
Vue.component('newsitem',newsitem);
Vue.component('bbncContent',bbncContent);
Vue.component('staff',staff);

// BBNC
import bbnc from "./components/bbnc/bbnc.vue";
Vue.component('bbnc',bbnc);

// dummies
import dummies from "./components/dummies/dummies.vue";
Vue.component('dummies',dummies);

// mus
import mus from "./components/mus/mus.vue";
Vue.component('mus',mus);

new Vue({
  el: '#app',
})



// WEBPACK FOOTER //
// ./src/main.js